import styled from "@emotion/styled";

export const Attachment = styled.div({
    fontSize: "16px",
    width: 400,
});

export const Footer = styled.footer({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});
